/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as TwoFactorRouteImport } from './routes/two-factor'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppApiKeysRouteImport } from './routes/_app.api-keys'
import { Route as AppBillingRouteImport } from './routes/_app.billing'
import { Route as AppConformanceRouteImport } from './routes/_app.conformance'
import { Route as AppEventsRouteImport } from './routes/_app.events'
import { Route as AppLogsRouteImport } from './routes/_app.logs'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppWebhooksRouteImport } from './routes/_app.webhooks'
import { Route as InviteInvitationIdRouteImport } from './routes/invite.$invitationId'
import { Route as AppSettingsIndexRouteImport } from './routes/_app.settings.index'
import { Route as AppSettingsMembersRouteImport } from './routes/_app.settings.members'
import { Route as AppSettingsOrganizationRouteImport } from './routes/_app.settings.organization'
import { Route as AppSettingsSecurityRouteImport } from './routes/_app.settings.security'
import { Route as AppShipmentsIndexRouteImport } from './routes/_app.shipments.index'
import { Route as AppShipmentsIdRouteImport } from './routes/_app.shipments.$id'
import { Route as AppWebhooksIndexRouteImport } from './routes/_app.webhooks.index'
import { Route as AppWebhooksDeliveriesRouteImport } from './routes/_app.webhooks.deliveries'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const TwoFactorRoute = TwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppApiKeysRoute = AppApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingRoute = AppBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppRoute,
} as any)
const AppConformanceRoute = AppConformanceRouteImport.update({
  id: '/conformance',
  path: '/conformance',
  getParentRoute: () => AppRoute,
} as any)
const AppEventsRoute = AppEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => AppRoute,
} as any)
const AppLogsRoute = AppLogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppWebhooksRoute = AppWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => AppRoute,
} as any)
const InviteInvitationIdRoute = InviteInvitationIdRouteImport.update({
  id: '/invite/$invitationId',
  path: '/invite/$invitationId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsMembersRoute = AppSettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsOrganizationRoute = AppSettingsOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSecurityRoute = AppSettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppShipmentsIndexRoute = AppShipmentsIndexRouteImport.update({
  id: '/shipments/',
  path: '/shipments/',
  getParentRoute: () => AppRoute,
} as any)
const AppShipmentsIdRoute = AppShipmentsIdRouteImport.update({
  id: '/shipments/$id',
  path: '/shipments/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppWebhooksIndexRoute = AppWebhooksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWebhooksRoute,
} as any)
const AppWebhooksDeliveriesRoute = AppWebhooksDeliveriesRouteImport.update({
  id: '/deliveries',
  path: '/deliveries',
  getParentRoute: () => AppWebhooksRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/two-factor': typeof TwoFactorRoute
  '/welcome': typeof WelcomeRoute
  '/api-keys': typeof AppApiKeysRoute
  '/billing': typeof AppBillingRoute
  '/conformance': typeof AppConformanceRoute
  '/events': typeof AppEventsRoute
  '/logs': typeof AppLogsRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/webhooks': typeof AppWebhooksRouteWithChildren
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/settings/members': typeof AppSettingsMembersRoute
  '/settings/organization': typeof AppSettingsOrganizationRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/shipments/$id': typeof AppShipmentsIdRoute
  '/webhooks/deliveries': typeof AppWebhooksDeliveriesRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/shipments/': typeof AppShipmentsIndexRoute
  '/webhooks/': typeof AppWebhooksIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/two-factor': typeof TwoFactorRoute
  '/welcome': typeof WelcomeRoute
  '/api-keys': typeof AppApiKeysRoute
  '/billing': typeof AppBillingRoute
  '/conformance': typeof AppConformanceRoute
  '/events': typeof AppEventsRoute
  '/logs': typeof AppLogsRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/': typeof AppIndexRoute
  '/settings/members': typeof AppSettingsMembersRoute
  '/settings/organization': typeof AppSettingsOrganizationRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/shipments/$id': typeof AppShipmentsIdRoute
  '/webhooks/deliveries': typeof AppWebhooksDeliveriesRoute
  '/settings': typeof AppSettingsIndexRoute
  '/shipments': typeof AppShipmentsIndexRoute
  '/webhooks': typeof AppWebhooksIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/two-factor': typeof TwoFactorRoute
  '/welcome': typeof WelcomeRoute
  '/_app/api-keys': typeof AppApiKeysRoute
  '/_app/billing': typeof AppBillingRoute
  '/_app/conformance': typeof AppConformanceRoute
  '/_app/events': typeof AppEventsRoute
  '/_app/logs': typeof AppLogsRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/webhooks': typeof AppWebhooksRouteWithChildren
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/_app/': typeof AppIndexRoute
  '/_app/settings/members': typeof AppSettingsMembersRoute
  '/_app/settings/organization': typeof AppSettingsOrganizationRoute
  '/_app/settings/security': typeof AppSettingsSecurityRoute
  '/_app/shipments/$id': typeof AppShipmentsIdRoute
  '/_app/webhooks/deliveries': typeof AppWebhooksDeliveriesRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/shipments/': typeof AppShipmentsIndexRoute
  '/_app/webhooks/': typeof AppWebhooksIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/signup'
    | '/two-factor'
    | '/welcome'
    | '/api-keys'
    | '/billing'
    | '/conformance'
    | '/events'
    | '/logs'
    | '/settings'
    | '/webhooks'
    | '/invite/$invitationId'
    | '/settings/members'
    | '/settings/organization'
    | '/settings/security'
    | '/shipments/$id'
    | '/webhooks/deliveries'
    | '/settings/'
    | '/shipments/'
    | '/webhooks/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/signup'
    | '/two-factor'
    | '/welcome'
    | '/api-keys'
    | '/billing'
    | '/conformance'
    | '/events'
    | '/logs'
    | '/invite/$invitationId'
    | '/'
    | '/settings/members'
    | '/settings/organization'
    | '/settings/security'
    | '/shipments/$id'
    | '/webhooks/deliveries'
    | '/settings'
    | '/shipments'
    | '/webhooks'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/signup'
    | '/two-factor'
    | '/welcome'
    | '/_app/api-keys'
    | '/_app/billing'
    | '/_app/conformance'
    | '/_app/events'
    | '/_app/logs'
    | '/_app/settings'
    | '/_app/webhooks'
    | '/invite/$invitationId'
    | '/_app/'
    | '/_app/settings/members'
    | '/_app/settings/organization'
    | '/_app/settings/security'
    | '/_app/shipments/$id'
    | '/_app/webhooks/deliveries'
    | '/_app/settings/'
    | '/_app/shipments/'
    | '/_app/webhooks/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  TwoFactorRoute: typeof TwoFactorRoute
  WelcomeRoute: typeof WelcomeRoute
  InviteInvitationIdRoute: typeof InviteInvitationIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/two-factor': {
      id: '/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof TwoFactorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/api-keys': {
      id: '/_app/api-keys'
      path: '/api-keys'
      fullPath: '/api-keys'
      preLoaderRoute: typeof AppApiKeysRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing': {
      id: '/_app/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AppBillingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/conformance': {
      id: '/_app/conformance'
      path: '/conformance'
      fullPath: '/conformance'
      preLoaderRoute: typeof AppConformanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/events': {
      id: '/_app/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof AppEventsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logs': {
      id: '/_app/logs'
      path: '/logs'
      fullPath: '/logs'
      preLoaderRoute: typeof AppLogsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/webhooks': {
      id: '/_app/webhooks'
      path: '/webhooks'
      fullPath: '/webhooks'
      preLoaderRoute: typeof AppWebhooksRouteImport
      parentRoute: typeof AppRoute
    }
    '/invite/$invitationId': {
      id: '/invite/$invitationId'
      path: '/invite/$invitationId'
      fullPath: '/invite/$invitationId'
      preLoaderRoute: typeof InviteInvitationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/members': {
      id: '/_app/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AppSettingsMembersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/organization': {
      id: '/_app/settings/organization'
      path: '/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof AppSettingsOrganizationRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/security': {
      id: '/_app/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AppSettingsSecurityRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/shipments/': {
      id: '/_app/shipments/'
      path: '/shipments'
      fullPath: '/shipments/'
      preLoaderRoute: typeof AppShipmentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shipments/$id': {
      id: '/_app/shipments/$id'
      path: '/shipments/$id'
      fullPath: '/shipments/$id'
      preLoaderRoute: typeof AppShipmentsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/webhooks/': {
      id: '/_app/webhooks/'
      path: '/'
      fullPath: '/webhooks/'
      preLoaderRoute: typeof AppWebhooksIndexRouteImport
      parentRoute: typeof AppWebhooksRoute
    }
    '/_app/webhooks/deliveries': {
      id: '/_app/webhooks/deliveries'
      path: '/deliveries'
      fullPath: '/webhooks/deliveries'
      preLoaderRoute: typeof AppWebhooksDeliveriesRouteImport
      parentRoute: typeof AppWebhooksRoute
    }
  }
}

interface AppSettingsRouteChildren {
  AppSettingsMembersRoute: typeof AppSettingsMembersRoute
  AppSettingsOrganizationRoute: typeof AppSettingsOrganizationRoute
  AppSettingsSecurityRoute: typeof AppSettingsSecurityRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsMembersRoute: AppSettingsMembersRoute,
  AppSettingsOrganizationRoute: AppSettingsOrganizationRoute,
  AppSettingsSecurityRoute: AppSettingsSecurityRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppWebhooksRouteChildren {
  AppWebhooksDeliveriesRoute: typeof AppWebhooksDeliveriesRoute
  AppWebhooksIndexRoute: typeof AppWebhooksIndexRoute
}

const AppWebhooksRouteChildren: AppWebhooksRouteChildren = {
  AppWebhooksDeliveriesRoute: AppWebhooksDeliveriesRoute,
  AppWebhooksIndexRoute: AppWebhooksIndexRoute,
}

const AppWebhooksRouteWithChildren = AppWebhooksRoute._addFileChildren(
  AppWebhooksRouteChildren,
)

interface AppRouteChildren {
  AppApiKeysRoute: typeof AppApiKeysRoute
  AppBillingRoute: typeof AppBillingRoute
  AppConformanceRoute: typeof AppConformanceRoute
  AppEventsRoute: typeof AppEventsRoute
  AppLogsRoute: typeof AppLogsRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppWebhooksRoute: typeof AppWebhooksRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppShipmentsIdRoute: typeof AppShipmentsIdRoute
  AppShipmentsIndexRoute: typeof AppShipmentsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppApiKeysRoute: AppApiKeysRoute,
  AppBillingRoute: AppBillingRoute,
  AppConformanceRoute: AppConformanceRoute,
  AppEventsRoute: AppEventsRoute,
  AppLogsRoute: AppLogsRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppWebhooksRoute: AppWebhooksRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppShipmentsIdRoute: AppShipmentsIdRoute,
  AppShipmentsIndexRoute: AppShipmentsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  TwoFactorRoute: TwoFactorRoute,
  WelcomeRoute: WelcomeRoute,
  InviteInvitationIdRoute: InviteInvitationIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
